import PropTypes from "prop-types";

import CardCustom from "./CardCustomComponents/CardCustom";

import CardDeck from "react-bootstrap/CardDeck";

import Card from "react-bootstrap/Card";

import iconsAddToList from "../assets/svg/icons-addToList-second.svg";

import { useTranslation } from "react-i18next";
import CardTextCustom from "./CardCustomComponents/CardTextCustom";
import {
  TILE_TYPE_TEXT,
  TILE_TYPE_LINKS,
  TILE_TYPE_IMPACT,
  TILE_TYPE_DECISION,
  TILE_TYPE_DATE,
  TILE_TYPE_RISKS,
  TILE_TYPE_SOURCE,
  TILE_TYPE_GROUP_OF_TILES,
  TILE_TYPE_AI_ANALYSIS,
} from "../constants/stringConstants";
import CardLinksCustom from "./CardCustomComponents/CardLinksCustom";
import CardImpactCustom from "./CardCustomComponents/CardImpactCustom";
import CardDecisionCustom from "./CardCustomComponents/CardDecisionCustom";
import CardDateCustom from "./CardCustomComponents/CardDateCustom";
import CardRisksCustom from "./CardCustomComponents/CardRisksCustom";
import CardSourceCustom from "./CardCustomComponents/CardSourceCustom";
import CardGroupOfTilesCustom from "./CardCustomComponents/CardGroupOfTilesCustom";
import CardAiAnalysisCustom from "./CardCustomComponents/CardAiAnalysisCustom";

const CardsDeckCustom = ({
  classNameOfCardsColumns,
  classNameOfCard,
  classNameOfOverlay,
  loggedIn,
  cards,
  fromMySelection,
  setCreateNewGroupuOfTopicsShown,
  userEmail,
  userToken,
  curatedRegHubTopics,
  currentWorkspace,
  fromMyAssessment,
  setCreateNewTileIsShown,
  singleTopic,
  id,
  fromDocumentContainer,
  fromCardAssessmentContainer,
  fromCuratedByRegHub,
  addTopicFunctionality,
  canAddTopic,
}) => {
  const { t } = useTranslation();

  return (
    <CardDeck className={classNameOfCardsColumns}>
      {fromMySelection && loggedIn ? (
        <Card
          className={
            curatedRegHubTopics.length
              ? "create-new-topic-group-card homepage-card apply-border-white-color cursor-pointer"
              : "create-new-topic-group-card homepage-card apply-border-white-color cursor-not-allowed"
          }
          onClick={() => {
            if (curatedRegHubTopics.length) {
              setCreateNewGroupuOfTopicsShown(true);
            }
          }}
        >
          <Card.Body>
            <Card.Text>
              <img
                src={iconsAddToList}
                className="card-image create-new-topic-group"
                width={64}
                height={64}
              />
              <span className="card-text create-new-topic-group-text fs-16">
                {t("createNewGroupOfTopics")}
              </span>
            </Card.Text>
          </Card.Body>
        </Card>
      ) : (
        <> </>
      )}
      {fromCuratedByRegHub ? (
        <Card
          className={
            !canAddTopic
              ? "create-new-topic-group-card homepage-card apply-border-white-color cursor-not-allowed"
              : "create-new-topic-group-card homepage-card apply-border-white-color cursor-pointer"
          }
          onClick={addTopicFunctionality}
        >
          <Card.Body>
            <Card.Text>
              <img
                src={iconsAddToList}
                className="card-image create-new-topic-group"
                width={64}
                height={64}
              />
              <span className="card-text create-new-topic-group-text fs-16">
                {t("addTopic")}
              </span>
              <br />
            </Card.Text>
          </Card.Body>
        </Card>
      ) : (
        <> </>
      )}
      {fromMyAssessment ? (
        <Card
          className={
            loggedIn
              ? "create-new-topic-group-card homepage-card apply-border-white-color create-new-tile-card cursor-pointer"
              : "create-new-topic-group-card homepage-card apply-border-white-color create-new-tile-card cursor-not-allowed"
          }
          onClick={() => {
            if (loggedIn) {
              setCreateNewTileIsShown(true);
            }
          }}
        >
          <Card.Body>
            <Card.Text>
              <img
                src={iconsAddToList}
                className="card-image create-new-topic-group create-new-tile"
                width={64}
                height={64}
              />
              <span
                className="card-text create-new-topic-group-text fs-16"
                style={{ marginBottom: "32px" }}
              >
                {t("addATile")}
              </span>
            </Card.Text>
          </Card.Body>
        </Card>
      ) : (
        <> </>
      )}
      {cards.length && typeof cards.map === "function" && !fromMyAssessment ? (
        cards.map((card) => {
          return (
            <CardCustom
              key={card.TOPIC_ID + "card"}
              card={card}
              classNameOfCard={classNameOfCard}
              classNameOfOverlay={classNameOfOverlay}
              loggedIn={loggedIn}
              createdByUser={userEmail === card.CREATED_BY}
              userToken={userToken}
              userEmail={userEmail}
              curatedRegHubTopics={curatedRegHubTopics}
              currentWorkspace={currentWorkspace}
            />
          );
        })
      ) : (
        <div className="display-none" />
      )}
      {cards.length && typeof cards.map === "function" && fromMyAssessment ? (
        cards.map((card, index) => {
          if (card.TILE_TYPE.toLowerCase() === TILE_TYPE_TEXT) {
            return (
              <CardTextCustom
                key={"card-text" + index}
                card={card}
                userEmail={userEmail}
                singleTopic={singleTopic}
                userToken={userToken}
                currentWorkspace={currentWorkspace}
                id={id}
                fromDocumentContainer={fromDocumentContainer}
                fromCardAssessmentContainer={fromCardAssessmentContainer}
              />
            );
          } else if (card.TILE_TYPE.toLowerCase() === TILE_TYPE_LINKS) {
            return (
              <CardLinksCustom
                key={"card-link" + index}
                card={card}
                userEmail={userEmail}
                singleTopic={singleTopic}
                userToken={userToken}
                currentWorkspace={currentWorkspace}
                id={id}
                fromDocumentContainer={fromDocumentContainer}
                fromCardAssessmentContainer={fromCardAssessmentContainer}
              />
            );
          } else if (card.TILE_TYPE.toLowerCase() === TILE_TYPE_IMPACT) {
            return (
              <CardImpactCustom
                key={"card-impact" + index}
                card={card}
                userEmail={userEmail}
                singleTopic={singleTopic}
                userToken={userToken}
                currentWorkspace={currentWorkspace}
                id={id}
                fromDocumentContainer={fromDocumentContainer}
                fromCardAssessmentContainer={fromCardAssessmentContainer}
              />
            );
          } else if (card.TILE_TYPE.toLowerCase() === TILE_TYPE_DECISION) {
            return (
              <CardDecisionCustom
                key={"card-decision" + index}
                card={card}
                userEmail={userEmail}
                singleTopic={singleTopic}
                userToken={userToken}
                currentWorkspace={currentWorkspace}
                id={id}
                fromDocumentContainer={fromDocumentContainer}
                fromCardAssessmentContainer={fromCardAssessmentContainer}
              />
            );
          } else if (card.TILE_TYPE.toLowerCase() === TILE_TYPE_DATE) {
            return (
              <CardDateCustom
                key={"card-date" + index}
                card={card}
                userEmail={userEmail}
                singleTopic={singleTopic}
                userToken={userToken}
                currentWorkspace={currentWorkspace}
                id={id}
                fromDocumentContainer={fromDocumentContainer}
                fromCardAssessmentContainer={fromCardAssessmentContainer}
              />
            );
          } else if (card.TILE_TYPE.toLowerCase() === TILE_TYPE_RISKS) {
            return (
              <CardRisksCustom
                key={"card-risks" + index}
                card={card}
                userEmail={userEmail}
                singleTopic={singleTopic}
                userToken={userToken}
                currentWorkspace={currentWorkspace}
                id={id}
                fromDocumentContainer={fromDocumentContainer}
                fromCardAssessmentContainer={fromCardAssessmentContainer}
              />
            );
          } else if (card.TILE_TYPE.toLowerCase() === TILE_TYPE_SOURCE) {
            return (
              <CardSourceCustom
                key={"card-risks" + index}
                card={card}
                userEmail={userEmail}
                singleTopic={singleTopic}
                userToken={userToken}
                currentWorkspace={currentWorkspace}
                id={id}
                fromDocumentContainer={fromDocumentContainer}
                fromCardAssessmentContainer={fromCardAssessmentContainer}
              />
            );
          } else if (
            card.TILE_TYPE.toLowerCase() ===
            TILE_TYPE_GROUP_OF_TILES.toLowerCase()
          ) {
            return (
              <CardGroupOfTilesCustom
                key={"card-group-tiles" + index}
                card={card}
                userEmail={userEmail}
                singleTopic={singleTopic}
                userToken={userToken}
                currentWorkspace={currentWorkspace}
                id={id}
                fromDocumentContainer={fromDocumentContainer}
                fromCardAssessmentContainer={fromCardAssessmentContainer}
              />
            );
          } else if (
            card.TILE_TYPE.toLowerCase() === TILE_TYPE_AI_ANALYSIS.toLowerCase()
          ) {
            return (
              <CardAiAnalysisCustom
                key={"card-ai-analysis" + index}
                card={card}
                userEmail={userEmail}
                singleTopic={singleTopic}
                userToken={userToken}
                currentWorkspace={currentWorkspace}
                id={id}
                fromDocumentContainer={fromDocumentContainer}
                fromCardAssessmentContainer={fromCardAssessmentContainer}
              />
            );
          }
          return null;
        })
      ) : (
        <div className="display-none" />
      )}
    </CardDeck>
  );
};

CardsDeckCustom.propTypes = {
  classNameOfCardsColumns: PropTypes.string.isRequired,
  classNameOfCard: PropTypes.string.isRequired,
  classNameOfOverlay: PropTypes.string.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      CREATED_BY: PropTypes.string,
      SUBSCRIPTION: PropTypes.string,
      TOPIC_AUDIENCE: PropTypes.string,
      TOPIC_ICON_PATH: PropTypes.string,
      TOPIC_ID: PropTypes.number,
      TOPIC_NAME: PropTypes.string,
      TOPIC_SEARCHTAGS: PropTypes.string,
      TOPIC_STATUS: PropTypes.string,
    })
  ),
  fromMySelection: PropTypes.bool.isRequired,
  setCreateNewGroupuOfTopicsShown: PropTypes.func.isRequired,
  userEmail: PropTypes.string.isRequired,
  userToken: PropTypes.string.isRequired,
  curatedRegHubTopics: PropTypes.arrayOf(
    PropTypes.shape({
      CREATED_BY: PropTypes.string,
      SUBSCRIPTION: PropTypes.string,
      TOPIC_AUDIENCE: PropTypes.string,
      TOPIC_ICON_PATH: PropTypes.string,
      TOPIC_ID: PropTypes.number,
      TOPIC_NAME: PropTypes.string,
      TOPIC_SEARCHTAGS: PropTypes.string,
      TOPIC_STATUS: PropTypes.string,
    })
  ),
  currentWorkspace: PropTypes.shape({
    WORKSPACE_TYPE: PropTypes.string,
  }),
  fromMyAssessment: PropTypes.bool,
  setCreateNewTileIsShown: PropTypes.func,
  singleTopic: PropTypes.shape({}),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fromDocumentContainer: PropTypes.bool,
  fromCardAssessmentContainer: PropTypes.bool,
  fromCuratedByRegHub: PropTypes.bool,
  addTopicFunctionality: PropTypes.func,
  canAddTopic: PropTypes.bool,
};

CardsDeckCustom.defaultProps = {
  classNameOfCardsColumns: "",
  classNameOfCard: "",
  classNameOfOverlay: "",
  loggedIn: false,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      CREATED_BY: "",
      SUBSCRIPTION: "FALSE",
      TOPIC_AUDIENCE: "",
      TOPIC_ICON_PATH: "",
      TOPIC_ID: 0,
      TOPIC_NAME: "",
      TOPIC_SEARCHTAGS: "",
      TOPIC_STATUS: "",
    })
  ),
  fromMySelection: false,
  setCreateNewGroupuOfTopicsShown: () => {},
  userEmail: "",
  userToken: "",
  curatedRegHubTopics: [],
  currentWorkspace: {},
  fromMyAssessment: false,
  setCreateNewTileIsShown: () => {},
  singleTopic: {},
  id: "",
  fromDocumentContainer: false,
  fromCardAssessmentContainer: false,
  fromCuratedByRegHub: false,
  addTopicFunctionality: () => {},
  canAddTopic: false,
};

export default CardsDeckCustom;
